export function arrToQueryString(operator: string, arr: string[]) {
  let arrQueryString = '';
  if ( operator === 'and') {
    arrQueryString = '[' + arr.join(',') + ']';
  }
  else  if ( operator === 'or') {
    arrQueryString = arr.join(',');
  }
  return arrQueryString;
}
